import React from "react";

function ExamModuleViewStudent(props) {
  return (
    <>
      {props?.classValue && props?.assessmentSubjectValue ? (
        <>
          {props?.routineData?.length > 0 &&
          props?.filtereduniqueDates?.length > 0 ? (
            <>
              {/* <table className='table table-bordered table-striped' border="1" style={{ borderCollapse: 'collapse', width: '100%' }}> */}
              <div className="arr-table-container routine-table">
                <table className="arr-table" border={1}>
                  <thead>
                    <tr>
                      {/* added minwidth style to evenly distribute width in table column /header */}
                      <th>
                        <div style={{ fontSize: "14px", fontWeight: 600 }}>
                          Date
                        </div>
                      </th>
                      <th>
                        <div style={{ fontSize: "14px", fontWeight: 600 }}>
                          Subjects
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {props?.filtereduniqueDates?.map((date, index) => (
                      <tr key={index}>
                        <td>
                          <div style={{ fontSize: "14px", fontWeight: 600 }}>
                            {date}
                          </div>
                        </td>
                        <td>
                          <div>
                            {props?.filteredTable[date.split(" ")[0]]?.map(
                              (subjectData, index) => (
                                <div key={index}>
                                  <span style={{ fontSize: "14px" }}>
                                    {subjectData}
                                  </span>
                                </div>
                              ),
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          ) : (
            <>
              <p className="text-center mt-2">
                The selected assessment is either not configured for the
                specified class, or there are no students available in the
                class.
              </p>
            </>
          )}
        </>
      ) : (
        <>
          <p className="text-center mt-2">
            Select the above field to view the records.
          </p>
        </>
      )}
    </>
  );
}

export default ExamModuleViewStudent;
